'use client'

import IconAlert from '@/components/assets/icon_alert.svg'
import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useTranslations } from 'next-intl'

type AgeVerificationModalProps = {
  onCancel?: () => void
  onAction?: () => void
}

export default function AgeVerificationModal({ onCancel, onAction }: AgeVerificationModalProps) {
  const t = useTranslations()
  return (
    <DefaultAlertDialog
      open={true}
      titleIcon={<IconAlert className="h-[40px] w-[40px] fill-[#F8E64A]" />}
      title={t('loading-screen.device-alert.title-age-verification')}
      description={t('loading-screen.device-alert.description-age-verification')}
      cancelText={t('loading-screen.device-alert.leave-age-verification')}
      actionText={t('loading-screen.device-alert.check-age-verification')}
      onCancel={onCancel}
      onAction={onAction}
      allowOutsideInteraction={true}
    />
  )
}
